import { type SbBlokData, storyblokEditable } from "@storyblok/react";

import { ProductList } from "@/components/ProductList";
import getLink from "@/lib/storyblok/getLink";
import useResolvedProductCards from "@/lib/storyblok/useResolvedProductCard";

import type { StoryblokLinkBlok } from "../StoryblokLink/StoryblokLink";

export interface FeaturedProductsBlok extends SbBlokData {
  products: number[];
  title: string;
  bigCardsOnMobile: boolean;
  link: StoryblokLinkBlok[];
}

export interface FeaturedProductsProps {
  blok: FeaturedProductsBlok;
}

export const FeaturedProducts = ({ blok }: FeaturedProductsProps) => {
  const products =
    useResolvedProductCards(blok?.products || [], "single", blok?._uid!) || [];

  const link = getLink(blok?.link[0]?.link);

  return (
    <div key={blok?._uid} {...storyblokEditable(blok)}>
      {products.length > 0 ? (
        <ProductList products={products} title={blok?.title} link={link} />
      ) : null}
    </div>
  );
};
